<template>
    <section class="padding-vertical-content mb-3 mb-lg-4">
        <div>
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-row>
                    <b-col cols="12" class="pb-2">
                        <h3>Importe total de la categoría: {{ importe | formatear_precio }}</h3>
                        <h4>¿Desea aplicar un descuento?</h4>
                    </b-col>
                    <b-col cols="12">
                        <DescuentoComponent :data="base" index="0" :desactivar="false" :importe="importe"/>
                    </b-col>
                    <b-col cols="12" class=" text-right mt-4">
                        <div class="text-right mt-3">
                            <button type="button" @click="volver" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-1" :disabled="!paso_activo">
                                <span>{{ $t('formularios.atras') }}</span>
                            </button>
                            <button type="submit" data-cy="terminar-paso-descuento" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-2" :disabled="!paso_activo">
                                <span>{{ $t('formularios.continuar') }}</span>
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </div>
    </section>
</template>

<script>
    import DescuentoComponent from '../../components/DescuentoComponent.vue';

    export default {
        props: {
            base: {
                type: Object,
                required: true
            },
            esMovil: {
                type: Boolean,
                default: false
            },
            paso_activo: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            importe() {
                let importe = 0;

                importe = importe + this.base.categoria_base.precio;

                if (this.base.indumentariasElegidas) {
                    for (let i in this.base.indumentariasElegidas) {
                        if (this.base.indumentariasElegidas[i].incluida && this.base.indumentariasElegidas[i].unidades == 1) {
                            importe = importe + 0;
                        } else {
                            importe = importe + parseFloat(this.base.indumentariasElegidas[i].precio_total);
                        }
                    }
                }

                return importe;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.guardarDatosComprador();
                }
            },
            guardarDatosComprador() {
                let params = {
                    lista_id: this.lista_abonados.id,
                    descuento_aplicado: this.base.descuento_aplicado || 0,
                    descuento_integro: this.base.descuento_integro || 0,
                    session_id: this.base.categoria_base.session_id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.bases.guardar-descuentos'), params).then(res => {
                    this.$emit('terminado');
                }).catch(error => {
                    console.error(error);
                    this.$toast.error('Ha ocurrido un error');
                });
            },
            volver() {
                this.$emit('volver');
            }
        },
        components: {
            DescuentoComponent
        }
    }
</script>

